import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import searchSalesOrderRequest from "./requests/searchSalesOrderRequest";
import getSalesOrderRequest from "./requests/getSalesOrderRequest";
import issueSalesOrderRequest from "./requests/issueSalesOrderRequest";
import unissueSalesOrderRequest from "./requests/unissueSalesOrderRequest";
import cancelSalesOrderRequest from "./requests/cancelSalesOrderRequest";
import closeShortSalesOrderRequest from "./requests/closeShortSalesOrderRequest";
import deleteSalesOrdersRequest from "./requests/deleteSalesOrdersRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";
import closeShortSalesOrderItemRequest from "./requests/closeShortSalesOrderItemRequest";

const salesOrdersEndpoints: RequestDefinitionData[] = [
    searchSalesOrderRequest,
    getSalesOrderRequest,
    issueSalesOrderRequest,
    unissueSalesOrderRequest,
    cancelSalesOrderRequest,
    closeShortSalesOrderRequest,
    closeShortSalesOrderItemRequest,
    deleteSalesOrdersRequest,
];

export const salesOrdersHeader = {
    title: 'Sales Orders',
    description: 'This is an object representing a Fishbowl sales order.',
    linkName: 'Sales Orders',
    link: 'https://www.fishbowlinventory.com/wiki/Sales_Order',
    endpoints: salesOrdersEndpoints,
};

export const jsonObject: Json = {
    title: 'THE SALES ORDER OBJECT',
    json: {
        "id": 72,
        "number": "10075",
        "carrier": {
            "id": 4,
            "name": "Fedex",
            "service": {
                "id": 8,
                "name": "Ground"
            }
        },
        "fobPointName": "Origin",
        "paymentTerms": {
            "id": 5,
            "name": "2% 10 NET 40"
        },
        "customer": {
            "id": 43,
            "name": "Big Al's Bike Shop"
        },
        "vendorPoNumber": "",
        "customerPoNumber": "",
        "customerContact": "Big Al's Bike Shop",
        "salesperson": {
            "id": 1,
            "name": "admin"
        },
        "deliverTo": "Big Al's Bike Shop",
        "revisionNumber": 1,
        "lastModified": {
            "username": "",
            "dateLastModified": "2025-06-13T23:38:07.239-06"
        },
        "dateCreated": "2025-03-28T08:54:22.000-06",
        "dateScheduled": "2025-03-28T08:54:22.000-06",
        "dateCompleted": "2025-03-28T08:54:22.000-06",
        "totalTax": "0",
        "totalPrice": "50",
        "mcTotalTax": "0",
        "mcTotalPrice": "50",
        "totalIncludesTax": false,
        "locationGroup": {
            "id": 5,
            "name": "SLC"
        },
        "note": "",
        "url": "",
        "email": "",
        "phone": "801-932-1101",
        "shipToAddress": {
            "name": "Big Al's Bike Shop",
            "street": "Big Al's Bike Shop",
            "city": "Seattle",
            "state": "WA",
            "postalCode": "98199",
            "country": "UNITED STATES"
        },
        "billToAddress": {
            "name": "Big Al's Bike Shop",
            "street": "Big Al's Bike Shop",
            "city": "Seattle",
            "state": "WA",
            "postalCode": "98199",
            "country": "UNITED STATES"
        },
        "status": "Fulfilled",
        "class": {
            "id": 1,
            "name": "None"
        },
        "shipTerms": "Prepaid & Billed",
        "type": "Standard",
        "soItems": [
            {
                "id": 160,
                "product": {
                    "id": 81,
                    "name": "B203",
                    "description": "Basic Brake Cables"
                },
                "type": {
                    "id": 10,
                    "name": "Sale"
                },
                "uom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "lineNumber": 1,
                "customerPartNumber": "",
                "unitPrice": "10",
                "totalTax": "0",
                "totalPrice": "50",
                "mcTotalTax": "0",
                "mcTotalPrice": "0",
                "taxRate": {
                    "id": 1,
                    "name": "None",
                    "rate": 0.0
                },
                "dateLastFulfilled": "2025-03-28T08:54:22.000-06",
                "dateScheduled": "2025-03-28T08:54:22.000-06",
                "revision": "",
                "note": "",
                "status": "Fulfilled",
                "quantity": "5",
                "quantityFulfilled": "5",
                "quantityPicked": "0",
                "class": {
                    "id": 1,
                    "name": "None"
                },
                "customFields": []
            }
        ],
        "customFields": [
            {
                "id": 20,
                "name": "Custom",
                "type": "Text"
            }
        ]
    },
};

export const salesOrderAttributes: Attribute[] = [
    {
        name: 'id',
        type: 'integer',
        description: 'The sales order\'s unique identification number.'
    },
    {
        name: 'number',
        type: 'string',
        description: 'The sales order number.'
    },
    {
        name: 'status',
        type: 'string',
        description: 'The order status.'
    },
    {
        name: 'class',
        type: 'reference object',
        description: 'The class category.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the object.',
            }
        ]
    },
    {
        name: 'carrier',
        type: 'reference object',
        description: 'The shipping carrier.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the object.',
            },
            {
                name: 'service',
                type: 'reference object',
                optional: true,
                description: 'The carrier service.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the object.',
                    },
                ]
            }
        ]
    },
    {
        name: 'fobPointName',
        type: 'string',
        description: 'Indicates when ownership/liability of the order transfers to the purchaser.'
    },
    {
        name: 'paymentTerms',
        type: 'reference object',
        description: 'The terms of payment on the order.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the object.',
            }
        ]
    },
    {
        name: 'shipTerms',
        type: 'string',
        description: 'The shipping terms on the order.',
    },
    {
        name: 'type',
        type: 'string: \'Standard\' | \'Point of Sale\'',
        description: 'Indicates whether the order is a standard or point of sale sales order.',
    },
    {
        name: 'customer',
        type: 'reference object',
        description: 'The customer on the sales order.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the object.',
            }
        ]
    },
    {
        name: 'vendorPoNumber',
        type: 'string',
        description: 'The vendor purchase order number.',
    },
    {
        name: 'customerPoNumber',
        type: 'string',
        description: 'The customer purchase order number.',
    },
    {
        name: 'salesperson',
        type: 'reference object',
        description: 'The Fishbowl user that created the order.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the object.',
            }
        ]
    },
    {
        name: 'customerContact',
        type: 'string',
        description: 'The name of the customer contact.'
    },
    {
        name: 'deliverTo',
        type: 'string',
        description: 'The intended recipient of the order.',
    },
    {
        name: 'revisionNumber',
        type: 'integer',
        description: 'The revision number.',
    },
    {
        name: 'lastModified',
        type: 'object',
        description: 'Timestamp of when the order was last modified and the user that made the modifications.',
        children: [
            {
                name: 'username',
                type: 'string',
                description: 'The username of the user last modified.',
            },
            {
                name: 'dateLastModified',
                type: 'date',
                description: 'The date last modified.',
            }
        ]
    },
    {
        name: 'dateCreated',
        type: 'date',
        description: 'Timestamp of when the order was created.',
    },
    {
        name: 'dateRevision',
        type: 'date',
        description: 'Timestamp of when the order was last revised.',
    },
    {
        name: 'dateScheduled',
        type: 'date',
        description: 'Timestamp of when the order was scheduled.',
    },
    {
        name: 'dateCompleted',
        type: 'date',
        description: 'Timestamp of when the order was completed.',
    },
    {
        name: 'taxRate',
        type: 'reference object',
        description: 'The tax rate on the order.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the object.',
            },
            {
                name: 'rate',
                type: 'double',
                description: 'The tax rate.',
            },
        ]
    },
    {
        name: 'totalTax',
        type: 'money',
        description: 'The total amount of tax on the order.',
    },
    {
        name: 'totalPrice',
        type: 'money',
        description: 'The total price of the order.',
    },
    {
        name: 'mcTotalTax',
        type: 'money',
        description: 'The multi-currency total tax of the order.',
    },
    {
        name: 'mcTotalPrice',
        type: 'money',
        description: 'The multi-currency total price of the order.',
    },
    {
        name: 'totalIncludesTax',
        type: 'boolean',
        description: 'Indicates if the order total includes tax.',
    },
    {
        name: 'locationGroup',
        type: 'reference object',
        description: 'The location group the order belongs to.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the object.',
            }
        ]
    },
    {
        name: 'note',
        type: 'string',
        description: 'The order\'s note field.',
    },
    {
        name: 'url',
        type: 'string',
        description: 'The url link on the order.',
    },
    {
        name: 'currency',
        type: 'reference object',
        description: 'The currency used on the order.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the object.',
            },
            {
                name: 'code',
                type: 'string',
                description: 'The currency code.',
            },
            {
                name: 'rate',
                type: 'number',
                description: 'The currency exchange rate.',
            },
            {
                name: 'homeCurrency',
                type: 'boolean',
                description: 'Indicates if the currency is the home currency.',
            }
        ]
    },
    {
        name: 'email',
        type: 'string',
        description: 'The customer\'s email address for the order.',
    },
    {
        name: 'phone',
        type: 'string',
        description: 'The customer\'s phone number for the order.',
    },
    {
        name: 'shipToAddress',
        type: 'object',
        description: 'The shipping address on the order.',
        children: [
            {
                name: 'name',
                type: 'string',
                description: 'The name on the address.',
            },
            {
                name: 'street',
                type: 'string',
                description: 'The street line.',
            },
            {
                name: 'city',
                type: 'string',
                description: 'The city.',
            },
            {
                name: 'state',
                type: 'string',
                description: 'The state\'s abbreviation.',
            },
            {
                name: 'postalCode',
                type: 'string',
                description: 'The postal code.',
            },
            {
                name: 'country',
                type: 'string',
                description: 'The country\'s abbreviation.',
            }
        ]
    },
    {
        name: 'billToAddress',
        type: 'object',
        description: 'The bill to address on the order.',
        children: [
            {
                name: 'name',
                type: 'string',
                description: 'The name on the address.',
            },
            {
                name: 'street',
                type: 'string',
                description: 'The street line.',
            },
            {
                name: 'city',
                type: 'string',
                description: 'The city.',
            },
            {
                name: 'state',
                type: 'string',
                description: 'The state\'s abbreviation.',
            },
            {
                name: 'postalCode',
                type: 'string',
                description: 'The postal code.',
            },
            {
                name: 'country',
                type: 'string',
                description: 'The country\'s abbreviation.',
            }
        ]
    },
    {
        name: 'soItems',
        type: 'list',
        description: 'A list of the sales order items.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identifier for the order item.',
            },
            {
                name: 'product',
                type: 'reference object',
                description: 'The product on the order item.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the object.',
                    },
                    {
                        name: 'description',
                        type: 'string',
                        description: 'The description of the object.',
                    },
                ]
            },
            {
                name: 'type',
                type: 'reference object',
                description: 'The order item\'s type.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the object.',
                    }
                ]
            },
            {
                name: 'status',
                type: 'string',
                description: 'The status of the order item.',
            },
            {
                name: 'parentKitSoItem',
                type: 'reference object',
                description: 'The kit order item. Only present when this order item is part of a kit.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the object.',
                    },
                ]
            },
            {
                name: 'uom',
                type: 'reference object',
                description: 'The product unit of measure.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the object.',
                    },
                    {
                        name: 'abbreviation',
                        type: 'string',
                        description: 'The abbreviated name.',
                    }
                ]
            },
            {
                name: 'lineNumber',
                type: 'integer',
                description: 'The line number for the order item.',
            },
            {
                name: 'customerPartNumber',
                type: 'string',
                description: 'The customer\'s number for the part.',
            },
            {
                name: 'quantity',
                type: 'quantity',
                description: 'The quantity to be fulfilled.',
            },
            {
                name: 'quantityFulfilled',
                type: 'quantity',
                description: 'The quantity already fulfilled.',
            },
            {
                name: 'quantityPicked',
                type: 'quantity',
                description: 'The quantity already picked.',
            },
            {
                name: 'unitPrice',
                type: 'money',
                description: 'The unit price of the product.',
            },
            {
                name: 'totalTax',
                type: 'money',
                description: 'The total tax of the product.',
            },
            {
                name: 'totalPrice',
                type: 'money',
                description: 'The total price of the product.',
            },
            {
                name: 'mcTotalTax',
                type: 'money',
                description: 'The multi-currency total tax of the product.',
            },
            {
                name: 'mcTotalPrice',
                type: 'money',
                description: 'The multi-currency total price of the product.',
            },
            {
                name: 'taxRate',
                type: 'reference object',
                description: 'The tax rate for the order item. This object is ignored for companies in the United States.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the object.',
                    },
                    {
                        name: 'rate',
                        type: 'double',
                        description: 'The tax rate.',
                    },
                ]
            },
            {
                name: 'dateLastFulfilled',
                type: 'date',
                description: 'The most recent fulfilled date for a partially or completely fulfilled order item.',
            },
            {
                name: 'dateScheduled',
                type: 'date',
                description: 'Timestamp of when the order is scheduled to be fulfilled.',
            },
            {
                name: 'revision',
                type: 'string',
                description: 'The revision number for the order item.',
            },
            {
                name: 'class',
                type: 'reference object',
                description: 'The class category for the order item.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the object.',
                    },
                ]
            },
            {
                name: 'note',
                type: 'string',
                description: 'The note on the order item.',
            },
            {
                name: 'customer',
                type: 'reference object',
                description: 'The customer on the order item.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the object.',
                    },
                ]
            },
            {
                name: 'customFields',
                type: 'list',
                description: 'A list of custom fields associated with the line item.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The custom field\'s unique identifier.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the custom field.',
                    },
                    {
                        name: 'value',
                        type: 'string',
                        description: 'The custom field\'s value.'
                    },
                    {
                        name: 'type',
                        type: 'string',
                        description: 'The category of the custom field\'s value.'
                    },
                ]
            },
        ]
    },
    {
        name: 'customFields',
        type: 'list',
        description: 'A list of custom fields associated with the order.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The custom field\'s unique identifier.',

            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the custom field.',
            },
            {
                name: 'value',
                type: 'string',
                description: 'The custom field\'s value.'
            },
            {
                name: 'type',
                type: 'string',
                description: 'The category of the custom field\'s value.'
            },
        ]
    },
];
